import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { View } from 'react-native';

import { getCuriosoSkin } from 'a/hub/selectors';
import LottieView from 'a/components/Lottie';

import getShowHideLayers from './CuriosolayerSelector';
import CuriosoAnimations from '../../data/bodyMovin/CuriosoRefactoring';

// Range of frames for each state of Curioso
const CURIOSO_STATES = {
  walk: [0, 60],
  idle: [60, 120],
  jump: [120, 170],
  happy: [170, 220],
  sad: [220, 275],
  curious: [275, 330],
};

/**
 *  Curioso componen that show Curioso with all applied augmentations
 */
class CuriosoComponent extends Component {
  constructor(props) {
    super(props);
    this.playCuriosoAnimation = this.playCuriosoAnimation.bind(this);
    this.isUmounted = false;
    this.animationRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.autoPlay) {
      this.loopIdleAnimation();
    }
  }

  componentWillUnmount() {
    this.isUmounted = true;
  }

  /**
    * These methods should be called from parent Components
      where <Curioso> will be included using refs e.g.
    * this.curiosoRef = React.createRef();
    * <Curioso
          width={300}
          height={300}
          autoPlay
          ref={this.curiosoRef}
      />
    * and then from parent component we can lunch Curiosos methods:
        this.this.curiosoRef.current.playCuriosoAnimation('jump') e.t.c
 */

  setCuriosoLayersVisibility = (JSONSource, layersToHide = []) => {
    // make copy of source
    const newJSONSource = JSON.parse(JSON.stringify(JSONSource));
    newJSONSource.assets.forEach((asset, i) => {
      if (asset.layers) {
        const newLayersArray = [];
        asset.layers.forEach((layer) => {
          if (!layersToHide.includes(layer.nm)) {
            newLayersArray.push(layer);
          }
        });
        newJSONSource.assets[i].layers = newLayersArray;
      }
    });
    return newJSONSource;
  };

  // IDLE animation (loped)
  loopIdleAnimation = () => {
    if (this.isUmounted) {
      return;
    }
    this.animationRef.current.play(...CURIOSO_STATES.idle, () => {
      this.loopIdleAnimation();
    });
  };

  // walk animation
  startWalking = () => {
    if (this.isUmounted) {
      return;
    }
    this.animationRef.current.play(...CURIOSO_STATES.walk, () => {
      this.startWalking();
    });
  };

  /**
    * play another Animation
    * walk ,idle, jump, happy, sad, curios
 */
  playCuriosoAnimation(type) {
    this.animationRef.current.reset();
    // return promise
    return new Promise((resolve) => {
      this.animationRef.current.play(...CURIOSO_STATES[type], () => {
        this.loopIdleAnimation();
        resolve();
      });
    });
  }

  render() {
    const { hideLayers } = this.props.layersData;
    const rawCuriosoAnimation = CuriosoAnimations[this.props.curiosoSkin];
    const lottieSource = this.setCuriosoLayersVisibility(rawCuriosoAnimation, hideLayers);
    const flipStyle = this.props.isCuriosoTurnedRight ? { transform: [{ scaleX: -1 }] } : {};
    return (
      <View
        style={[
          styles.curiosoContainer,
          flipStyle,
        ]}
      >
        <LottieView
          source={lottieSource}
          style={{ width: this.props.width, height: this.props.height }}
          ref={this.animationRef}
        />
      </View>
    );
  }
}

CuriosoComponent.propTypes = {
  curiosoSkin: PropTypes.string.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  autoPlay: PropTypes.bool,
  layersData: PropTypes.object.isRequired,
  isCuriosoTurnedRight: PropTypes.bool,
};

CuriosoComponent.defaultProps = {
  width: 350,
  height: 350,
  autoPlay: false,
  isCuriosoTurnedRight: false,
};

const mapStateToProps = state => ({
  // apply selector to calculate what layers should be hide and visible
  layersData: getShowHideLayers(state),
  curiosoSkin: getCuriosoSkin(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(CuriosoComponent);

const styles = {
  curiosoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  lottieStyle: {
    height: 400,
    width: 400,
  },
};
